export const GET_USERS = "GET_USERS";
export const GET_USER_BY_ID = "GET_USER_BY_ID";
export const SET_USER_TO_NULL = "SET_USER_TO_NULL";
